import React from 'react';
import { UI_STYLES } from '../../styles/uiStyles';

interface SubmitButtonProps {
  text: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

export const SubmitButton: React.FC<SubmitButtonProps> = ({ 
  text,
  onClick,
  disabled = false,
  className = ''
}) => {
  return (
    <div className="flex justify-center">
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        className={`w-full max-w-xs ${UI_STYLES.buttonGradient} ${UI_STYLES.buttonGradientHover} text-white rounded-xl py-3 mb-3 text-[17px] shadow-lg transition disabled:opacity-50 disabled:cursor-not-allowed ${
          disabled ? 'opacity-50 cursor-not-allowed' : ''
        } ${className}`}
      >
        {text}
      </button>
    </div>
  );
};

export default SubmitButton; 
